module.exports = __webpack_public_path__ + "svg/upload-avatar.svg?093a4993daba2ae9e0722c07fb209fff";